const dashboardApi = {
  GET_DASHBOARD: "/api/restaurant/dashboard",
};
export default dashboardApi;
